//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { email, required, minLength } from 'vuelidate/lib/validators';
import * as api from '@/services/api';
export default {
  data() {
    return {
      email: '',
      subject: '',
      message: '',
      errorMessage: null
    };
  },
  validations: {
    email: { email, required },
    subject: { required },
    message: { required, minLength: minLength(20) }
  },
  methods: {
    async contact() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      try {
        await api.send(
          this.email,
          'BOMIST [support] ' + this.subject,
          this.message
        );
        this.clear();
        this.$refs.modalSent.open();
      } catch (err) {
        this.$toast.error(err.response ? err.response.data.message : err);
        if (this.$sentry) {
          this.$sentry.captureException(err);
        }
      }
    },
    handleSent() {
      this.$router.push('/');
    },
    clear() {
      this.email = '';
      this.subject = '';
      this.message = '';
      this.$v.$reset();
    }
  }
};
